import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="px-4 md:px-6 py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div>
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-book-read-line text-white text-xl"></i>
                </div>
                <span className="font-heading text-2xl font-bold">土豪漫画</span>
              </div>
              <p className="text-foreground-300 text-sm leading-relaxed mb-6 max-w-xs">
                土豪漫画网是国内领先的在线漫画阅读平台，提供漫画全集下拉式免费阅读服务。随时随地，畅享精彩漫画世界。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 text-foreground-300 hover:text-white hover:border-white transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 text-foreground-300 hover:text-white hover:border-white transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 text-foreground-300 hover:text-white hover:border-white transition-colors cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 text-foreground-300 hover:text-white hover:border-white transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold uppercase tracking-wider text-foreground-400 mb-6">漫画分类</h4>
              <div className="grid grid-cols-2 gap-2">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-foreground-300 text-sm hover:text-white transition-colors whitespace-nowrap py-1"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold uppercase tracking-wider text-foreground-400 mb-6">联系我们</h4>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <i className="ri-mail-line text-foreground-400 mt-0.5"></i>
                  <span className="text-foreground-300 text-sm">hello@i2p1d.com</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-phone-line text-foreground-400 mt-0.5"></i>
                  <span className="text-foreground-300 text-sm">400-888-6666</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-foreground-400 mt-0.5"></i>
                  <span className="text-foreground-300 text-sm">北京市朝阳区望京SOHO T2 12层</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="px-4 md:px-6 py-6">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-foreground-500 text-xs">
              &copy; {new Date().getFullYear()} 土豪漫画网 tuhaomanhua.com 版权所有
            </p>
            <div className="flex items-center gap-6">
              <Link to="/about" className="text-foreground-500 text-xs hover:text-white transition-colors whitespace-nowrap">关于我们</Link>
              <a href="#" className="text-foreground-500 text-xs hover:text-white transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-foreground-500 text-xs hover:text-white transition-colors whitespace-nowrap">服务条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}